
        import '/home/builduser/work/c1dd1064fea009a6/santa-editor/packages/tpa/panels/appImportPanel/components/emptyState/EmptyState.scss.css.virtualfile';
        module.exports = {"content-wrapper":"_content-wrapper_uju1o_1","contentWrapper":"_content-wrapper_uju1o_1"};